<template>
    <dialog ref="dialogRef" class="confirm-modal" :class="modalClass" @keydown.esc="closeDialog()">
        <div class="confirm-modal__content">
            <h2 class="confirm-modal__title" v-html="title"></h2>
            <p v-if="text" class="confirm-modal__text" v-html="text"></p>
        </div>
        <div class="confirm-modal__buttons">
            <button v-if="cancelText" @click="closeDialog()">{{ cancelText }}</button>
            <button v-if="submitText && submitAction" @click="submitDialog">{{ submitText }}</button>
            <button v-if="submit2Text && submit2Action" @click="submit2Dialog">{{ submit2Text }}</button>
        </div>
    </dialog>
</template>

<script lang="ts" setup>
import { onMounted, ShallowRef, useTemplateRef } from "vue";

import { ConfirmModal } from "@/shared/model/confirm-modal";
import { lockScroll, unlockScroll } from "v3-scroll-lock";

const props = defineProps<ConfirmModal>();
const emit = defineEmits(["close"]);

const dialog: Readonly<ShallowRef<HTMLDialogElement>> = useTemplateRef("dialogRef");

onMounted(() => {
    lockScroll(dialog.value, { reserveScrollBarGap: true });
    dialog.value.showModal();
});

const closeDialog = (doTheCancelAction: boolean = true) => {
    dialog.value.close();
    unlockScroll(dialog.value);

    if (props.cancelAction && doTheCancelAction) {
        props.cancelAction();
    }

    emit("close");
};

const submitDialog = () => {
    closeDialog(false);
    props.submitAction();
};
const submit2Dialog = () => {
    closeDialog(false);
    props.submit2Action();
};
</script>
